@if (cameras && cameras.length) {
  <section class="cameras">
    @for (camera of cameras; track camera; let i = $index) {
      <div>
        <div class="" (click)="selectItem(camera)">
          <div>
            <app-camara-box [selectable]="true" [camera]="camera"></app-camara-box>
          </div>
        </div>
      </div>
    }
  </section>
}

@if (!cameras) {
  <app-please-wait></app-please-wait>
}
@if (cameras && !cameras.length) {
  <div>
    <div class="nothing-returned">
      <app-info-box title="No camera devices" link="Find out more &rarr;" (trayLinkClicked)="clickShowMore()"> Your organisation has no cameras, timelapse and carpark light monitoring options are available. </app-info-box>
    </div>
  </div>
}
